import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import { Button } from 'primereact/button'

// styles
import style from '@aytm/app/stats/page/question-views/vk/components/views/chart/components/chart-buttons/styles/ChartButtons.module.scss'

const ChartButton = ({ children, active, buttonName, touched, handleClick }) => (
  <Button
    data-testid={`stat-vk-edit-${buttonName}`}
    className={classNames('p-button-rounded p-button-blue p-button-secondary', {
      [style.active]: active === buttonName,
      [style.touched]: touched
    })}
    name={buttonName}
    onClick={handleClick}
  >
    {children}
  </Button>
)

ChartButton.propTypes = {
  children: PropTypes.any,
  active: PropTypes.string,
  buttonName: PropTypes.string,
  touched: PropTypes.bool,
  handleClick: PropTypes.func
}

export default ChartButton
